export const calcPercentage = (percentage, totalValue) => {
  return Math.round((percentage / 100) * totalValue);
};
